import type { FaireProductEntity } from "../../entity_types/product";

export const p_k2bwut8tze: FaireProductEntity = {
  token: "p_k2bwut8tze",
  type: "product",
  name: "The Everything Tote",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl: "https://cdn.faire.com/fastly/3442a3bc77d75b1ce6ecc819d32c41d9634aa0b0f2d226bcb6a48899a78da0a0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/063ca7e532f3a2c961726c71cf433d3e23f70f6cd8914dfa5550f6c36d338c05.png",
    "https://cdn.faire.com/fastly/4a38c5a0e59ed2ba4d4289d70261968ff9519a4605b71dc2bf64d96032fedea3.png"
  ],
  priceDollars: 40,
  description: "Your do-anything, go-anywhere, everyday catch-all. An all around commuter companion, grocery haul Hercules, occasional weekender, sweaty gym clothes savior, and beach towel buddy. The everything tote is made from khaki canvas with a pistachio logo. Note: looks best when filled with Táche cartons.",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:00.404Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
